import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_TrailerTypes } from 'redux/modules/trailerTypes/Actions'
import { TTrailerType, TTrailerTypes } from 'redux/modules/trailerTypes/TReducer'
import { TStoreTemplate } from 'redux/config/root-types'

const client = RequestMethods()

export interface ISagaWorker_DeactivateTrailerType {
  id: number
}

export default function* SagaWorker_DeactivateTrailerType(action: PayloadAction<ISagaWorker_DeactivateTrailerType>) {
  const { id } = action.payload

  try {
    yield put(Actions_TrailerTypes.store.showLoader())

    yield call(async () => await client.put<TTrailerType>(`/trailer_types/${id}/deactivate`))

    const result: TStoreTemplate<TTrailerTypes> = yield call(
      async () => await client.get<TTrailerTypes>('/trailer_types'),
    )
    yield put(Actions_TrailerTypes.store.saveTrailerTypes(result))

    yield put(
      Actions_Notifications.store.setNotification({
        message: 'Trailer type successfully deactivated',
        type: 'Success',
      }),
    )
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_TrailerTypes.store.hideLoader())
  }
}
